export default "__VITE_ASSET__CfeyiwZ6__"